import { RISKMGMT } from "./action";

const initialState = {
  riskList: [],
  ticketList: [],
  unallocatedList: [],
  internalList: [],
  internalInventoryDest: [],
  invetory: [],
  fetchingComplete:false
};

export default function riskReducer(state = initialState, action) {
  switch (action.type) {
    case RISKMGMT.list.success:
      return {
        ...state,
        riskList: action.data
      };
    case RISKMGMT.unallocatedlist.success:
      return {
        ...state,
        unallocatedList: action.data
      };
    case RISKMGMT.internallist.success:
      return {
        ...state,
        internalList: action.data
      };
    case RISKMGMT.ticketList.success:
      return {
        ...state,
        ticketList: action.data
      };
    case RISKMGMT.internalInventoryDest.start:
      return {
        ...state,
        fetchingComplete:false,
        internalInventoryDest: []
      };
    case RISKMGMT.internalInventoryDest.success:
      return {
        ...state,
        fetchingComplete:true,
        internalInventoryDest: action.data
      };
      case RISKMGMT.inventory.success:
        return {
          ...state,
          invetory: action.data
        };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/riskmanagement/reducer.js